import aguardandoInicioSessao from './tours/aguardando-inicio-sessao';
import encerradaComRecurso from './tours/encerrada-com-recurso';
import prazosRecursais from './tours/prazos-recursais';
import manifestacaoIntencaoRecurso from './tours/manifestacao-intencao-recurso';
import recursosFormRazoes from './tours/recursos-form-razoes';
import recursosFormContrarrazoes from './tours/recursos-form-contrarrazoes';
import recursosFormConsideracao from './tours/recursos-form-consideracao';
import recursosFormJulgamento from './tours/recursos-form-julgamento';
import recursosEditarExcluir from './tours/recursos-editar-excluir';
import licitacoesFiltros from './tours/licitacoes-filtros';
import licitacoesCriar from './tours/licitacoes-criar';
import arpJornadas from './tours/arp-jornadas';
import recursosEditarExcluirHints from './hints/recursos-editar-excluir';
import voltarEtapaHints from './hints/voltar-etapa';
import voltarEtapaManifestacaoHints from './hints/voltar-etapa-manifestacao';

/**
 * Normaliza definição de feature (tour ou hint) para o contrato único.
 * @param {object} def
 * @param {'tour'|'hint'} defaultKind
 */
export function normalizeFeature(def, defaultKind = 'tour') {
  if (!def?.id) return null;

  const kind = def.kind || defaultKind;

  let canStart = () => true;
  if (typeof def.canStart === 'function') {
    canStart = def.canStart;
  } else if (typeof def.canShow === 'function') {
    canStart = def.canShow;
  }

  let requires = [];
  if (Array.isArray(def.requires)) {
    requires = def.requires;
  } else if (def.requiresTourId) {
    requires = [def.requiresTourId];
  }

  return {
    ...def,
    kind,
    label: def.label || def.id,
    version: def.version || 1,
    contexts: Array.isArray(def.contexts) ? def.contexts : [],
    scopes: Array.isArray(def.scopes) ? def.scopes : [],
    priority: Number.isFinite(def.priority) ? def.priority : 100,
    help: def.help !== false,
    requires,
    canStart,
    situation: def.situation != null ? Number(def.situation) : null,
  };
}

const rawFeatures = [
  aguardandoInicioSessao,
  encerradaComRecurso,
  prazosRecursais,
  manifestacaoIntencaoRecurso,
  recursosFormRazoes,
  recursosFormContrarrazoes,
  recursosFormConsideracao,
  recursosFormJulgamento,
  recursosEditarExcluir,
  licitacoesFiltros,
  licitacoesCriar,
  arpJornadas,
  recursosEditarExcluirHints,
  voltarEtapaHints,
  voltarEtapaManifestacaoHints,
];

const features = {};
rawFeatures.forEach(raw => {
  const defaultKind =
    raw.kind === 'hint' || typeof raw.hints === 'function' || Array.isArray(raw.hints)
      ? 'hint'
      : 'tour';
  const feature = normalizeFeature(raw, defaultKind);
  if (feature) features[feature.id] = feature;
});

export function getFeature(featureId) {
  return features[featureId] || null;
}

/** @deprecated Use getFeature */
export function getTour(tourId) {
  const feature = getFeature(tourId);
  return feature && feature.kind === 'tour' ? feature : feature;
}

export function listFeatureIds() {
  return Object.keys(features);
}

/** @deprecated Use listFeatureIds */
export function listTourIds() {
  return listFeatureIds().filter(id => features[id].kind === 'tour');
}

export function listFeaturesByContext(contextId) {
  return Object.values(features)
    .filter(feature => feature.contexts.includes(contextId))
    .sort((a, b) => a.priority - b.priority || a.id.localeCompare(b.id));
}

export function getFeaturePorSituacao(situation) {
  const situacao = Number(situation);
  return (
    Object.values(features).find(
      feature =>
        feature.kind === 'tour' &&
        feature.contexts.includes('auction.situation') &&
        feature.situation === situacao,
    ) || null
  );
}
